import React from 'react';
import LocationTemplate from './LocationTemplate';

const GodwinPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Godwin"
      stateName="North Carolina"
      countyName="Cumberland"
      zipCodes={["28344"]}
      latitude={35.2076}
      longitude={-78.6406}
      population={118}
      historicalFact="Incorporated in 1905, named after the Godwin family who were early settlers and landowners."
      nearbyTowns={[
        "Fayetteville, NC",
        "Dunn, NC",
        "Clinton, NC",
        "Wade, NC",
        "Erwin, NC",
        "Autryville, NC",
        "Linden, NC",
        "Eastover, NC"
      ]}
    />
  );
};

export default GodwinPage;